export interface PageDictionary {
  howItWorks: {
    title: string;
    subtitle: string;
    steps: {
      title: string;
      description: string;
      number?: string;
      image?: string;
    }[];
    demoChat: {
      messages: Message[];
    };
    demoChatNurture: {
      messages: Message[];
    };
    demoCopilot: {
      messages: Message[];
      senderNames: {
        buyer: string;
        agent: string;
      };
    };
    demoScheduler: {
      visits: {
        name: string;
        date: string;
        time: string;
        address: string;
        status: 'open' | 'sent';
        details?: {
          email: string;
          phone: string;
          role: string;
          jobStatus: string;
          income: number;
          languages: string[];
          householdSize: number;
          numOfWorkers: number;
          moveInDate: string;
          note: string;
        };
      }[];
    };
  };
  results?: {
    title: string;
    metrics: {
      value: string;
      description: string;
    }[];
  };
  landingPage: {
    heroText: string;
    heroDescription: string;
  };
  common: {
    getStarted: string;
    getStarted2: string;
    login: string;
  };
  contactUs: {
    title: string;
    description: string;
    emailButton: string;
    callButton: string;
  };
  footnote: {
    text: string;
  };
  heroMessages: {
    bubbles: string[];
  };
  privacyPolicy: {
    title: string;
  };
}

interface Message {
  from: string;
  content: string;
  timestamp: string;
}

const dictionaries = {
  en: () => import('./en.json').then((module) => module.default),
  fr: () => import('./fr.json').then((module) => module.default),
  nl: () => import('./nl.json').then((module) => module.default),
};

export const getDictionary = async (locale: string, questions?: any) => {
  const languageCode = locale.toLowerCase().split('-')[0];
  const dictionaryLoader =
    dictionaries[languageCode as keyof typeof dictionaries] || dictionaries.en;
  const dictionary = await dictionaryLoader();

  return {
    ...dictionary,
    chat: {
      ...dictionary.chat,
      suggestedQuestions: {
        ...dictionary.chat.suggestedQuestions,
        ...questions?.chat?.suggestedQuestions
      }
    }
  };
  
}; 